import { useMutation } from "react-query";
import { useToast } from "@chakra-ui/react";
import { t } from "i18next";
import { postAuthorizeUser } from "./postAuthorizeUser";
import { TData, TAuthorizeUserBody } from "./types";
import { translations } from "../../../i18n/translations";
import { setAccessToken } from "../../../utils/setAccessToken";
import { setUserRevenueCatId } from "../../../utils/User/setUserRevenueCatId";

export const useAuthorizeUser = () => {
  const toast = useToast();
  return useMutation<TData, unknown, TAuthorizeUserBody>(
    (payload) => postAuthorizeUser(payload),
    {
      onError: () => {
        toast({
          title: "Error",
          description: t<string>(translations.errors.authorization_error),
          status: "error",
          position: "top-right",
        });
      },
      onSuccess: (data) => {
        setAccessToken(data.accessToken);
        setUserRevenueCatId(data.userData?.revenueCatUserId as string);
      },
    }
  );
};
